// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-119d0032] .ant-modal-body {\n  max-height: 500px;\n  overflow-y: auto;\n}\n.name[data-v-119d0032] {\n  margin: 20px 0;\n  font-weight: bold;\n  padding-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
